import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SkillOrb from "./Components/SkillOrb";

const PortfolioSection = () => {
    const [activeTab, setActiveTab] = useState("experience");

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const experiences = [
        {
            period: "Juni 2025 - Current",
            company: "Bank Saqu",
            position: "Frontend Developer",
            location: "Jakarta, Indonesia",
            description: "Adding new features to existing systems, Fixed bugs and errors, Language used React Js"
        },
        {
            period: "Mei 2024 - Mei 2025",
            company: "Bank CIMB Niaga",
            position: "Frontend Developer",
            location: "Jakarta, Indonesia",
            description: "Adding new features to existing systems, Fixed bugs and errors, Language used React Js with bootstrap and tailwind"
        },
        {
            period: "Nov 2022 - Mei 2024",
            company: "PT Solusi Eksplorasi Rembulan Utama (SERU) - Placement on PT Garudafood",
            position: "Mobile Developer (React Native)",
            location: "Jakarta, Indonesia",
            description: "Build apps for market retail and system for manage branch of delivery, create with web base"
        },
        {
            period: "Apr 2022 - Nov 2022",
            company: "PT Solusi Aplikasi Indonesia (VARX)",
            position: "Fullstack Developer",
            location: "Bali, Indonesia",
            description: "Web for marketplace and build for CMS to manage the marketplace"
        },
        {
            period: "Jan 2022 - Current",
            company: "Self-Employed",
            position: "Software Engineer",
            location: "Indonesia",
            description: "Providing software development services to various clients, specializing in creating functional and efficient applications."
        },
        {
            period: "Jan 2017 - Current",
            company: "Self-Employed",
            position: "Graphic Designer",
            location: "Indonesia",
            description: "Providing graphic design services to various clients, specializing in creating visually appealing designs."
        }
    ];

    const projects = [
        { name: "Branch Delivery System", description: "System for manage branch of delivery system, create with web base", tech: ["React.js"] },
        { name: "Valida", description: "Web for bank statement analyzer and extraction", tech: ["React.js", "REST API", "TailwindCSS"] },
        { name: "CIMB Niaga", description: "Central management system of bank CIMB Niaga", tech: ["React.js", "Bootstrap"] },
        { name: "BarangKulakan", description: "Marketplace. Mobile app with React Native & CMS with ReactJs", tech: ["React Native", "React.js", "Redux", "Google Play Console"] },
        { name: "GrosirApp", description: "Manage order for wholesaler, base Mobile apps with React Native", tech: ["React Native", "Redux", "React Navigation", "Google Play Console", "Reanimated"] },
        { name: "Nusameta", description: "Marketplace for NFT and CMS. Build with Next Js", tech: ["Next.js", "Tailwind CSS"] },
        { name: "Asfin", description: "WEB for event GIIAS 2023. Build with ReactJs", tech: ["React.js", "Tailwind CSS"] },
        { name: "Semua Kopi Indonesia", description: "Marketplace for coffee and CMS, Build with Next Js with tailwindCss", tech: ["Next.js", "Tailwind CSS", "Golang", "ArangoDB"] },
        { name: "Sehatmental.id", description: "Website for community mental health, Build with Next Js with tailwindCss", tech: ["Next.js", "Tailwind CSS"] },
        { name: "Furnitureshop", description: "Marketplace furniture and home decor custom WEB base, Build with CodeIgniter", tech: ["CodeIgniter", "PHP", "MySQL"] }
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100 } }
    };

    return (
        <div className="relative bg-[#0F0F0F] text-white py-12 px-6 sm:py-16 sm:px-10 md:py-20 md:px-12 lg:px-20 overflow-hidden min-h-screen">
            <div className="max-w-6xl mx-auto">

                <motion.header
                    initial={{ opacity: 0, y: -30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ type: "spring", bounce: 0.15, duration: 0.8 }}
                    className="text-center mb-12 sm:mb-16"
                >
                    <motion.h1
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ delay: 0.2, duration: 0.8, type: "spring", bounce: 0.15 }}
                        className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6"
                    >
                        My <span className="text-[#2F8F6F]">Portfolio</span>
                    </motion.h1>
                    <motion.p
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ delay: 0.4, duration: 0.6 }}
                        className="text-base sm:text-lg md:text-xl text-slate-300 max-w-3xl mx-auto"
                    >
                        Explore my journey as a Frontend Developer with expertise in modern web technologies
                    </motion.p>
                </motion.header>

                <motion.nav
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ delay: 0.3, duration: 0.8, type: "spring", bounce: 0.15 }}
                    className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-10 sm:mb-12"
                >
                    {["experience", "skills", "projects"].map((tab, index) => (
                        <motion.button
                            key={tab}
                            onClick={() => handleTabChange(tab)}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ delay: 0.4 + index * 0.1, type: "spring", bounce: 0.15, duration: 0.6 }}
                            className={`px-6 py-3 sm:px-8 sm:py-3 rounded-full font-semibold text-sm sm:text-base md:text-lg capitalize transition-all duration-300 ${activeTab === tab
                                ? "bg-[#2F8F6F] text-white shadow-lg shadow-[#2F8F6F]/30"
                                : "bg-[#0B3D2E]/40 text-[#2F8F6F]/70 hover:bg-[#145A43]/50 hover:text-white"
                                } touch-manipulation`}
                            aria-selected={activeTab === tab}
                            aria-controls={`tabpanel-${tab}`}
                        >
                            {tab}
                        </motion.button>
                    ))}
                </motion.nav>

                <AnimatePresence mode="wait">

                    {activeTab === "experience" && (
                        <motion.section
                            key="experience"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.3 }}
                            className="space-y-8 sm:space-y-10"
                        >
                            <motion.h2
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ delay: 0.1, duration: 0.4 }}
                                className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-[#2F8F6F] mb-10"
                            >
                                Work Experience
                            </motion.h2>
                            <motion.div
                                variants={containerVariants}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, margin: "-80px" }}
                                className="space-y-8"
                            >
                                {experiences.map((exp, index) => (
                                    <motion.article
                                        key={index}
                                        variants={itemVariants}
                                        whileHover={{
                                            scale: 1.02,
                                            boxShadow: "0 20px 40px rgba(47, 143, 111, 0.15)",
                                            borderColor: "rgba(47, 143, 111, 0.5)"
                                        }}
                                        className="bg-[#0B3D2E]/15 backdrop-blur-sm rounded-xl p-6 sm:p-8 border border-[#145A43]/40 transition-all duration-300 cursor-pointer"
                                    >
                                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 gap-3">
                                            <h3 className="text-xl sm:text-2xl font-bold text-[#2F8F6F]">
                                                {exp.position}
                                            </h3>
                                            <motion.span
                                                whileHover={{ scale: 1.05 }}
                                                className="text-xs sm:text-sm bg-[#0B3D2E]/50 text-[#D7C7A1] px-3 py-1.5 rounded-full whitespace-nowrap"
                                            >
                                                {exp.period}
                                            </motion.span>
                                        </div>
                                        <h4 className="text-lg sm:text-xl font-semibold text-white mb-2">
                                            {exp.company}
                                        </h4>
                                        <p className="text-gray-400 text-sm sm:text-base mb-4">
                                            {exp.location}
                                        </p>
                                        <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
                                            {exp.description}
                                        </p>
                                    </motion.article>
                                ))}
                            </motion.div>
                        </motion.section>
                    )}

                    {activeTab === "skills" && (
                        <motion.section
                            key="skills"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.3 }}
                            className="space-y-10"
                        >
                            <SkillOrb />
                        </motion.section>
                    )}

                    {activeTab === "projects" && (
                        <motion.section
                            key="projects"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.3 }}
                            className="space-y-10"
                        >
                            <motion.h2
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ delay: 0.1, duration: 0.4 }}
                                className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-[#2F8F6F] mb-10"
                            >
                                Featured Projects
                            </motion.h2>
                            <motion.div
                                variants={containerVariants}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, margin: "-80px" }}
                                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8"
                            >
                                {projects.map((project, index) => (
                                    <motion.article
                                        key={index}
                                        variants={itemVariants}
                                        whileHover={{
                                            y: -8,
                                            scale: 1.03,
                                            boxShadow: "0 25px 50px rgba(47, 143, 111, 0.2)",
                                            borderColor: "rgba(47, 143, 111, 0.5)"
                                        }}
                                        className="bg-[#0B3D2E]/15 backdrop-blur-sm rounded-xl p-6 border border-[#145A43]/40 transition-all duration-300 group cursor-pointer"
                                    >
                                        <h3 className="text-lg sm:text-xl font-bold text-[#2F8F6F] mb-3 group-hover:text-[#D7C7A1] transition-colors">
                                            {project.name}
                                        </h3>
                                        <p className="text-gray-300 text-sm sm:text-base mb-5 leading-relaxed">
                                            {project.description}
                                        </p>
                                        <div className="flex flex-wrap gap-2">
                                            {project.tech.map((tech, i) => (
                                                <motion.span
                                                    key={i}
                                                    initial={{ opacity: 0, x: -10 }}
                                                    animate={{ opacity: 1, x: 0 }}
                                                    transition={{ delay: index * 0.08 + i * 0.05 }}
                                                    whileHover={{ scale: 1.05 }}
                                                    className="bg-[#0B3D2E]/50 text-[#D7C7A1] px-3 py-1.5 rounded text-xs sm:text-sm font-medium border border-[#2F8F6F]/20"
                                                >
                                                    {tech}
                                                </motion.span>
                                            ))}
                                        </div>
                                    </motion.article>
                                ))}
                            </motion.div>
                        </motion.section>
                    )}

                </AnimatePresence>
            </div>
        </div>
    );
};

export default PortfolioSection;